import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../_services/admin.service';
import { AppService } from '../app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Tag} from '../_models/tag';
import {ToastsManager} from 'ng2-toastr';
import {ACLFeature} from '../_models/acl-feature';
import {Permissions} from '../_services/permissions';

const log = Log.create('Tags');

@Component({
    selector: 'edit-tags-drilldown',
    styleUrls: ['tags-drilldown.less'],
    templateUrl: 'tags-drilldown.component.html'
})

export class TagsDrilldownComponent implements OnInit, OnDestroy {
    tagFamilies = [];
    tags = [];
    showTags = false;
    canWriteTags = false;
    canReadTags = false;
    familyId = null;
    showDeleteModal = false;
    selectedTagIdForDeletion: number = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private admin: AdminService,
        private appService: AppService,
        private renderer: Renderer2,
        private permissions: Permissions,
        private toast: ToastsManager
    ) {}

    ngOnInit() {
        this.appService.headerData.title = '';
        this.appService.headerData.path = [];

        this.renderer.addClass(document.body, 'edit-section-tags');

        this.admin.getTagFamiliesController().subscribe((tagFamilies) => {
            this.tagFamilies = tagFamilies;

            this.route.params.subscribe(params => {
                this.familyId = params['family'] == null || params['family'] === 'null' ? null : params['family'];

                if (this.familyId) {
                    this.showTags = true;
                    this.admin.getTagFamilyController(this.familyId).subscribe((tagFamily) => {
                        this.tags = tagFamily.tags;
                        this.appService.headerData.title = tagFamily.name;
                        this.appService.tagBreadcrumbs.breadcrumbs = [{id: null, name: 'Label families'}];
                    });
                } else {
                    this.showTags = false;
                    this.appService.headerData.title = 'Label families';
                    this.appService.tagBreadcrumbs.breadcrumbs = [];
                }
            });
        });

      this.permissions.hasFeature(ACLFeature.WRITE_TAGS)
        .subscribe((success) => {
          this.canWriteTags = success;
        });

      this.permissions.hasFeature(ACLFeature.READ_TAGS)
        .subscribe((success) => {
          this.canReadTags = success;
        });
    }

    public tagFamilyClick(tagFamily) {
        this.router.navigate([{family: tagFamily.id}], {relativeTo: this.route} );
    }

    public onTagItemClick(tagId) {
      if (this.canWriteTags) {
        this.router.navigate(['/labels/label/' + tagId], {relativeTo: this.route} );
      }
    }

    public addNewTag() {
        if (this.familyId) {
            this.router.navigate(['/labels/new-label/' + this.familyId], {relativeTo: this.route} );
        }
    }

    public onDeleteFamily($event, id) {
        $event.stopPropagation();
        this.selectedTagIdForDeletion = id;
        this.showDeleteModal = true;
    }

    public onDeleteConfirmed(confirmed) {
        if (confirmed) {
            this.admin.deleteTagController(this.selectedTagIdForDeletion).subscribe((data) => {
                if (data.status === 'fail' || data.status === 'error') {
                    this.toast.error(data.data);
                } else {
                    this.toast.success(`Label has been deleted successfully.`);
                    this.router.navigate([{ family: this.familyId, refresh: Date.now() }]);
                }
                this.selectedTagIdForDeletion = null;
            });
        }
        this.showDeleteModal = false;
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'edit-section-tags');
    }
}



// WEBPACK FOOTER //
// ./src/app/tags-drilldown/tags-drilldown.component.ts